import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import productMenuItems from './productMenuItems';
import softwareErpDevelopmentHero from '../assets/images/main-slider/software-erp-development-hero.png';
import sectionVisualImage from '../assets/images/main-slider/software-erp-development-hero.png';

const schoolLoginUrl = 'https://www.swiftmazetech.com/school-management/login';
const schoolWhatsappUrl =
  'https://wa.me/919978623133?text=Hello%20SwiftMaze%20Tech%2C%20I%20want%20to%20know%20about%20SwiftMaze%20School%20Management%20Software.';

const schoolReviews = [
  {
    name: 'School Admin Team',
    position: 'Education Operations',
    rating: 5,
    message:
      'The school workflow keeps admissions, student details, fee records, and reports easier to manage from one place.',
    proofPoints: ['Admission flow', 'Fee clarity'],
  },
  {
    name: 'Tuition Class Owner',
    position: 'Coaching And Tuition',
    rating: 5,
    message:
      'A simple student management system is useful for handling enquiries, batches, fees, receipts, and daily records with less manual work.',
    proofPoints: ['Student records', 'Receipts'],
  },
  {
    name: 'Education Business Team',
    position: 'Institute Management',
    rating: 5,
    message:
      'Role-based access helps admins, principals, admission clerks, and fee clerks work with better control and clearer responsibility.',
    proofPoints: ['Role access', 'Reports'],
  },
];

const schoolManagementConfig = {
  seo: {
    title: 'School ERP Software In India For Schools & Tuition Institutes',
    description:
      'School ERP software in India for admissions, students, fees, attendance, exams, results, timetables, reports and role-based school or tuition management.',
    canonical: 'https://www.swiftmazetech.com/products/school-management/',
    ogImage: softwareErpDevelopmentHero,
    schemaName: 'SwiftMaze School ERP Software',
    schemaType: 'School ERP And Tuition Management Software',
    schemaEntityType: 'Product',
  },
  servicePath: '/products/school-management',
  relatedItems: productMenuItems,
  relatedTitle: 'Related Products',
  relatedText:
    'Explore SwiftMaze products for school operations, WhatsApp communication, medical business workflows, and structured team productivity.',
  hero: {
    image: softwareErpDevelopmentHero,
    kicker: 'School ERP Software In India',
    title: 'One School ERP For Admissions, Academics, Fees And Communication',
    lead:
      'Plan and manage the complete student journey in one configurable ERP for schools, tuition institutes and coaching classes, with institute-wise modules, role-based access and future-ready web and mobile experiences.',
    buttonLabel: 'Registered User Login',
    actionButtons: [
      {
        label: 'Watch Tutorial',
        url: 'https://www.youtube.com/watch?v=_WrA7qjYBIw',
        target: '_blank',
        variant: 'ghost',
        className: 'chrome-service-hero-youtube-button',
        icon: 'fa-youtube-play',
      },
      {
        label: 'Registered User Login',
        url: schoolLoginUrl,
        target: '_blank',
        icon: 'fa-sign-in',
      },
      {
        label: 'Chat On WhatsApp',
        url: schoolWhatsappUrl,
        target: '_blank',
        variant: 'ghost',
        icon: 'fa-whatsapp',
      },
    ],
    chips: ['School And Tuition ERP', 'Institute-Wise Modules', 'Role-Based Access', 'Parent And Teacher Apps'],
  },
  trustStrip: {
    items: [
      { value: 'Multi-Institute', label: 'Separate Institute Data And Settings' },
      { value: 'Configurable', label: 'Modules Enabled Institute-Wise' },
      { value: 'Role Based', label: 'Admin, Clerk, Teacher And Parent Access' },
      { value: 'Web + Mobile', label: 'Admin Web And Planned Flutter Apps' },
    ],
  },
  capability: {
    id: 'school-features',
    kicker: 'Core ERP Modules',
    title: 'School ERP Modules Designed Around Real Institute Workflows',
    text:
      'The product roadmap covers the operational and academic modules schools and tuition institutes need, while allowing SwiftMaze SuperAdmin to enable only the modules included for each institute.',
    items: [
      {
        icon: 'fa-user-plus',
        title: 'Inquiry And Admission Management',
        text:
          'Capture prospective student enquiries, schedule follow-ups, review admission details and create a student only after final confirmation.',
      },
      {
        icon: 'fa-user',
        title: 'Students, Parents And Classes',
        text:
          'Maintain student and guardian profiles with school classes and sections or tuition batches, while preserving academic-year enrollment history.',
      },
      {
        icon: 'fa-money',
        title: 'Fees, Payments And Receipts',
        text:
          'Configure class or batch fee plans, instalments, partial payments, discounts, late fees, payment modes and downloadable receipt records.',
      },
      {
        icon: 'fa-calendar-check-o',
        title: 'Attendance And Academics',
        text:
          'Manage student attendance, teachers, timetables, homework, offline exams, marks and progress reports from connected academic records.',
      },
      {
        icon: 'fa-mobile',
        title: 'Parent, Student And Teacher Apps',
        text:
          'Plan role-specific Flutter app experiences for parents, students and teachers using the same secure backend and institute data rules.',
      },
      {
        icon: 'fa-sliders',
        title: 'Module Control And Reports',
        text:
          'Enable modules institute-wise, restrict access by role and expose only the reports connected to modules available for that institute.',
      },
    ],
  },
  featureBreakdown: {
    kicker: 'Complete Module Coverage',
    title: 'From Student Enquiry To Academic Progress And Fee Reports',
    text:
      'SwiftMaze School ERP is planned as a connected system instead of separate registers. Each enabled module contributes to one reliable student, academic and financial record.',
    items: [
      {
        icon: 'fa-sign-in',
        title: 'Inquiry And Follow-Up',
        text:
          'Record prospective students, contact details, source, interested class or batch, follow-up date, notes and inquiry status.',
      },
      {
        icon: 'fa-graduation-cap',
        title: 'Admission And Student Creation',
        text:
          'Review admission information, preserve inquiry history and create the final student profile through a controlled confirmation step.',
      },
      {
        icon: 'fa-users',
        title: 'Class, Section And Batch Setup',
        text:
          'Support academic years, school classes and sections, or tuition batches and courses with structured student assignments.',
      },
      {
        icon: 'fa-money',
        title: 'Fee Plans And Collection',
        text:
          'Create class or batch fee plans, assign categories, define schedules, collect full or partial payments and track outstanding amounts.',
      },
      {
        icon: 'fa-file-pdf-o',
        title: 'Receipts And Parent View',
        text:
          'Generate versioned receipt records for print, download and parent access, with optional WhatsApp sharing when the integration is enabled.',
      },
      {
        icon: 'fa-check-square-o',
        title: 'Attendance And Teacher Records',
        text:
          'Maintain teacher and employee information, record student attendance and provide role-appropriate attendance visibility.',
      },
      {
        icon: 'fa-pencil-square-o',
        title: 'Exams, Marks And Results',
        text:
          'Manage offline exams and tests, subject-wise marks, grades and progress reports, with planned Excel upload and PDF templates.',
      },
      {
        icon: 'fa-calendar',
        title: 'Timetable, Homework And Notices',
        text:
          'Share class or batch timetables, simple homework assignments and institute notices through the relevant user experience.',
      },
      {
        icon: 'fa-level-up',
        title: 'Promotion And Academic History',
        text:
          'Move eligible students to a new academic year, class or batch without overwriting earlier fees, attendance and result history.',
      },
      {
        icon: 'fa-bar-chart',
        title: 'Operational And Management Reports',
        text:
          'Review student, attendance, fee, pending-payment, exam, class, teacher and communication reports based on enabled modules.',
      },
    ],
  },
  contentSections: [
    {
      id: 'school-erp-admission-student-modules',
      kicker: 'Student Lifecycle',
      title: 'Admission And Student Management Software With Connected Records',
      paragraphs: [
        'A school ERP should preserve the journey from the first inquiry to confirmed admission instead of forcing staff to enter the same information repeatedly. SwiftMaze is planned around a traceable inquiry, follow-up, admission and student-creation workflow.',
        'Schools can work with classes and sections, while tuition institutes can use batches and courses. Parent or guardian information remains connected to the student, and academic-year enrollment history is retained for future reporting.',
      ],
      items: [
        {
          title: 'Inquiry Pipeline',
          text: 'Capture source, interested class or batch, next follow-up, notes and current status for every prospective student.',
        },
        {
          title: 'Admission Review',
          text: 'Review student, guardian, address and admission details before creating the permanent student record.',
        },
        {
          title: 'Student And Parent Profiles',
          text: 'Maintain organized student and guardian information with institute-scoped access and role-based visibility.',
        },
        {
          title: 'Academic Enrollment History',
          text: 'Track class, section, batch and academic-year movement without losing earlier institutional records.',
        },
      ],
    },
    {
      id: 'school-fee-management-software',
      kicker: 'Fee Management',
      title: 'School Fee Management Software From Plan Assignment To Receipt',
      paragraphs: [
        'Fee collection requires more than a payment entry. The planned ERP connects fee categories, class or batch plans, collection schedules, concessions, partial payments, overdue status, payment history and receipt snapshots.',
        'Cash, bank, UPI, cheque and future online payment records can follow controlled validation rules. Optional payment gateway and WhatsApp receipt delivery remain institute-configurable integrations rather than mandatory dependencies.',
      ],
      items: [
        {
          title: 'Class And Batch Fee Plans',
          text: 'Create reusable fee categories with monthly or fixed-session schedules and assign them to eligible students.',
        },
        {
          title: 'Partial And Full Payments',
          text: 'Record allowed payment amounts accurately while keeping paid, pending and overdue states separate.',
        },
        {
          title: 'Receipt PDF And History',
          text: 'Prepare print-ready, downloadable and versioned receipts backed by the payment snapshot at collection time.',
        },
        {
          title: 'Parent Receipt Access',
          text: 'Give authorized parents access to receipts for their linked students through the planned parent experience.',
        },
      ],
    },
    {
      id: 'school-academic-management-modules',
      kicker: 'Academic Operations',
      title: 'Attendance, Examination, Result And Daily Academic Modules',
      paragraphs: [
        'Connected academic modules help administrators and teachers avoid fragmented spreadsheets. Attendance, examinations, marks, timetables, homework, notices and student progress can use the same class, batch, subject and academic-year structure.',
        'Version 1 focuses on offline exams and tests. Online exams, question banks and homework submission workflows are not presented as standard v1 features.',
      ],
      items: [
        {
          title: 'Student Attendance',
          text: 'Record and review attendance with access appropriate to administrators, teachers and linked parents or students.',
        },
        {
          title: 'Offline Exams And Marks',
          text: 'Manage subjects, maximum marks, obtained marks, grades, percentages and optional rank information.',
        },
        {
          title: 'Results And Progress Cards',
          text: 'Prepare Gujarati or English progress-report templates with planned PDF viewing and download support.',
        },
        {
          title: 'Timetable, Homework And Notice',
          text: 'Publish routine academic information for the relevant class, batch, teacher, parent or student audience.',
        },
      ],
    },
    {
      id: 'school-erp-role-mobile-control',
      kicker: 'SaaS And Access Control',
      title: 'Institute-Wise Modules, Role-Based Access And Future Mobile Apps',
      paragraphs: [
        'SwiftMaze School ERP is being planned as a reusable multi-institute SaaS product. Institute data, settings, subscriptions, limits and enabled modules remain separate, while the platform owner controls institute access and module availability.',
        'Planned roles include SwiftMaze SuperAdmin, Institute Admin, Clerk, Teacher, Parent, Student and optional Driver. Admin workflows remain web-first, while the future common Flutter app can deliver role-specific parent, student and teacher experiences through the same backend.',
      ],
      items: [
        {
          title: 'SuperAdmin Module Control',
          text: 'Enable or disable modules institute-wise so unavailable features stay hidden from navigation, reports, routes and APIs.',
        },
        {
          title: 'Role And Record Scope',
          text: 'Limit each user to permitted actions and records instead of giving every staff member unrestricted access.',
        },
        {
          title: 'Institute Data Separation',
          text: 'Keep each school or tuition institute data set logically separated throughout web, mobile and backend workflows.',
        },
        {
          title: 'Shared Backend For Web And Flutter',
          text: 'Use shared API contracts and server-side validation while keeping web and mobile interfaces optimized for their users.',
        },
      ],
    },
    {
      id: 'optional-school-erp-modules',
      kicker: 'Optional Add-Ons',
      title: 'Enable Advanced School ERP Modules Only When Required',
      paragraphs: [
        'Not every institute needs every feature. Optional modules can be planned according to the institute type, selected plan, operating process and approved implementation scope.',
        'This keeps the daily interface simpler for staff and avoids presenting advanced integrations as mandatory parts of the core ERP.',
      ],
      items: [
        {
          title: 'Online Payments And Communication',
          text: 'Optional payment gateway, DLT SMS, WhatsApp templates, receipt sharing and app notifications with provider-wise settings.',
        },
        {
          title: 'Certificates And I-Cards',
          text: 'Template-based certificate and student I-Card generation with validation, preview and print-oriented output options.',
        },
        {
          title: 'Staff Attendance And Bus Tracking',
          text: 'Optional staff attendance workflows and driver-phone GPS bus tracking when enabled for the institute.',
        },
        {
          title: 'Recorded Lectures',
          text: 'Optional assigned lecture viewing for relevant classes or batches using a suitable external video provider.',
        },
      ],
    },
  ],
  cta: {
    id: 'school-free-access',
    kicker: 'School ERP Requirement Discussion',
    title: 'Plan The Right School ERP Modules For Your Institute',
    text:
      'Share your student strength, current registers, fee process, academic structure, staff roles and parent communication needs. We will help map the appropriate core and optional ERP modules for your school or tuition institute.',
    buttonLabel: 'Chat On WhatsApp',
    buttonUrl: schoolWhatsappUrl,
    buttonTarget: '_blank',
    secondaryButtonLabel: 'Request ERP Consultation',
    secondaryButtonSubject: 'School ERP Software Requirement Consultation',
  },
  ctaPlacement: 'beforeFeatureBreakdown',
  audience: {
    image: sectionVisualImage,
    imageAlt:
      'School admin team using school management software for admissions students fees and reports',
    kicker: 'Who It Supports',
    title:
      'School ERP Software For Schools, Tuition Institutes And Education Teams',
    text:
      'SwiftMaze is planned for institutions that need connected admissions, student records, academic operations, fee management and role-based access without maintaining disconnected registers.',
    items: [
      {
        icon: 'fa-university',
        title: 'Schools',
        text:
          'Manage classes, sections, admissions, students, parents, attendance, fees, examinations, results and institutional reports.',
      },
      {
        icon: 'fa-book',
        title: 'Tuition Classes',
        text:
          'Manage enquiries, batches, teachers, attendance, fee plans, tests, marks, homework and student communication.',
      },
      {
        icon: 'fa-graduation-cap',
        title: 'Coaching Institutes',
        text:
          'Organize course or batch enrollment, student attendance, payment history, offline tests and progress information.',
      },
      {
        icon: 'fa-users',
        title: 'Institute Admin And Clerk Teams',
        text:
          'Separate admission, student, fee, receipt and reporting actions according to approved staff permissions.',
      },
      {
        icon: 'fa-briefcase',
        title: 'Teachers, Parents And Students',
        text:
          'Provide role-specific access to attendance, timetable, homework, notices, results and receipts as modules are released.',
      },
      {
        icon: 'fa-cogs',
        title: 'Multi-Institute Education Groups',
        text:
          'Plan institute-wise data separation, module entitlements, subscriptions and operational controls for scalable management.',
      },
    ],
  },
  workflow: {
    kicker: 'Implementation Approach',
    title: 'How We Plan A School ERP Around Your Actual Workflow',
    text:
      'A successful school ERP starts with process clarity. We identify the institute structure, confirm module scope and prepare data, permissions and rollout stages before full adoption.',
    items: [
      {
        title: 'Understand Your Current Process',
        text:
          'Review existing inquiry, admission, student, attendance, fee, examination and reporting processes with your team.',
      },
      {
        title: 'Confirm Institute Structure',
        text:
          'Define school or tuition type, academic years, classes and sections or batches and courses, subjects and operational rules.',
      },
      {
        title: 'Select Core And Optional Modules',
        text:
          'Choose the required modules and integrations instead of loading the institute with features it will not use.',
      },
      {
        title: 'Prepare Roles, Data And Templates',
        text:
          'Map Admin, Clerk, Teacher, Parent and Student access, then prepare migration files, fee plans and document templates.',
      },
      {
        title: 'Test, Train And Roll Out',
        text:
          'Validate high-risk workflows such as admission and fee collection, train users and release modules in manageable stages.',
      },
    ],
  },
  security: {
    kicker: 'Access And Data Architecture',
    title: 'Role-Aware School ERP With Institute-Wise Data Separation',
    text:
      'The planned architecture treats backend validation, institute isolation, permissions and module access as core requirements across web and future Flutter clients.',
    items: [
      {
        icon: 'fa-lock',
        title: 'Backend-Enforced Role Access',
        text:
          'Define permitted records and actions for SuperAdmin, Institute Admin, Clerk, Teacher, Parent, Student and optional Driver roles.',
      },
      {
        icon: 'fa-file-text-o',
        title: 'Institute Data Isolation',
        text:
          'Keep every institute’s records, settings, subscriptions and module entitlements separated within the SaaS architecture.',
      },
      {
        icon: 'fa-check-square-o',
        title: 'Module-Level Access Control',
        text:
          'Hide and block disabled modules across menus, dashboards, direct routes, reports, mobile surfaces and backend APIs.',
      },
      {
        icon: 'fa-bar-chart',
        title: 'Audit And Operational Readiness',
        text:
          'Plan audit logs, backups, background jobs, exports and important change history for accountable operations.',
      },
    ],
    highlights: [
      {
        title: 'Admin Web Experience',
        text:
          'Give institute teams efficient access to operational modules, configuration, data entry and reports.',
      },
      {
        title: 'Flutter Mobile Direction',
        text:
          'Provide planned role-specific Parent, Student and Teacher experiences through a common Flutter app codebase.',
      },
      {
        title: 'Shared Business Rules',
        text:
          'Keep server-side validation and shared API contracts consistent while web and mobile interfaces remain purpose-built.',
      },
    ],
  },
  delivery: {
    id: 'school-erp-development',
    kicker: 'Product Development Roadmap',
    title: 'A Phased School ERP Rollout Instead Of One Risky Launch',
    text:
      'The current product foundation prioritizes admission, student, fee and receipt workflows. Additional academic, communication and mobile modules can follow through reviewed implementation phases.',
    items: [
      {
        number: '01',
        title: 'Foundation And Core Operations',
        text:
          'Establish institute configuration, roles, module control, inquiry, admission, students, fee plans, collection and receipts.',
      },
      {
        number: '02',
        title: 'Academic And Communication Modules',
        text:
          'Add attendance, teacher records, exams, marks, results, timetable, homework, notices and institute reporting.',
      },
      {
        number: '03',
        title: 'Mobile And Optional Integrations',
        text:
          'Release approved Flutter experiences and optional payment, SMS, WhatsApp, I-Card, certificate or tracking capabilities.',
      },
    ],
  },
  videoDemo: {
    kicker: 'Current Product Demo',
    title: 'See The SwiftMaze School ERP Workflow Foundation',
    text:
      'Watch the available product walkthrough. The wider module list on this page represents the planned ERP scope and phased product direction.',
    buttonLabel: 'Watch Tutorial Video',
    className: 'chrome-service-video-youtube-button',
    url: 'https://www.youtube.com/watch?v=_WrA7qjYBIw',
  },
  videoDemoPlacement: 'beforeDelivery',
  faq: {
    kicker: 'FAQ',
    title: 'Questions About SwiftMaze School ERP Software',
    text:
      'Important answers about module coverage, school and tuition workflows, access control, mobile apps and planned integrations.',
    items: [
      {
        question: 'What is school ERP software?',
        answer:
          'School ERP software connects administrative, academic and financial workflows such as admissions, student records, attendance, fees, examinations, results, communication and reports in one structured system.',
      },
      {
        question: 'Which modules are planned in SwiftMaze School ERP?',
        answer:
          'Planned core modules include inquiry, admission, students, parents, classes or batches, teachers, attendance, fees, receipts, offline exams, marks, results, timetable, notices, homework and reports. Availability depends on the implementation phase and modules enabled for the institute.',
      },
      {
        question: 'Can tuition classes and coaching institutes use this ERP?',
        answer:
          'Yes. Tuition institutes, coaching classes, commerce or science classes and education centers can use batch and course workflows instead of school-specific class and section workflows.',
      },
      {
        question: 'How does the inquiry and admission flow work?',
        answer:
          'The planned flow captures an inquiry and follow-ups, preserves its history, creates a linked admission for review and creates the student only through an explicit final confirmation.',
      },
      {
        question: 'What does the fee management module cover?',
        answer:
          'The planned fee module covers categories, class or batch plans, collection schedules, partial and full payments, discounts, late fees, payment modes, pending amounts, receipt history and fee reports.',
      },
      {
        question: 'Can every institute choose different modules?',
        answer:
          'Yes. SwiftMaze SuperAdmin controls module enablement institute-wise. Disabled modules should remain unavailable in navigation, dashboards, reports, direct routes, apps and backend APIs.',
      },
      {
        question: 'Will parents, students and teachers get a mobile app?',
        answer:
          'A common Flutter mobile app with role-specific Parent, Student and Teacher experiences is part of the planned architecture. Exact screens and release timing depend on the approved rollout phase.',
      },
      {
        question: 'Does the ERP include online payments, SMS and WhatsApp?',
        answer:
          'These are planned optional integrations. Payment gateway, DLT SMS and WhatsApp provider settings can be configured institute-wise when included in the implementation scope.',
      },
      {
        question: 'Does the ERP support exams and progress cards?',
        answer:
          'The planned v1 scope supports offline exams or tests, subject-wise marks, grades, percentages and Gujarati or English progress-report templates. Online exams and question banks are outside the standard v1 scope.',
      },
      {
        question: 'How is institute data protected in a multi-school ERP?',
        answer:
          'The architecture is planned around institute-wise data separation, backend-enforced permissions, module entitlements and shared API rules across web and mobile clients.',
      },
      {
        question: 'Can data be imported from existing Excel files?',
        answer:
          'Excel upload is planned for supported records such as students, marks and fees, with validation required before accepted data is saved.',
      },
      {
        question: 'Can our institute request custom modules?',
        answer:
          'Yes. We can review the requirement against the reusable ERP architecture and confirm whether it belongs in the core product, an optional module or a separately scoped customization.',
      },
    ],
  },
  reviews: {
    kicker: 'Feedback',
    title: 'Built For Practical School And Tuition Management',
    text:
      'The product direction is focused on daily education operations, admission flow, student records, fee collection, and role-based access.',
    items: schoolReviews,
  },
  finalCta: {
    className: '',
    kicker: 'Start Free',
    title: 'Start With SwiftMaze School Management Software',
    text:
      'Move your admissions, student records, fees, receipts, reports, and staff access into one simple school management system. Registered users can log in directly, and new schools can contact us on WhatsApp.',
    primaryButtonLabel: 'Chat On WhatsApp',
    primaryButtonUrl: schoolWhatsappUrl,
    primaryButtonTarget: '_blank',
    secondaryButtonLabel: 'Registered User Login',
    secondaryButtonUrl: schoolLoginUrl,
    secondaryButtonTarget: '_blank',
  },
  finalCtaPlacement: 'afterWorkflow',
  stickyMobileCta: {
    primaryButtonLabel: 'Chat On WhatsApp',
    primaryButtonUrl: schoolWhatsappUrl,
    primaryButtonTarget: '_blank',
    secondaryButtonLabel: 'Registered Login',
    secondaryButtonUrl: schoolLoginUrl,
    secondaryButtonTarget: '_blank',
  },
  inquiry: {
    defaultSubject: 'School Management Software',
    formTitle: 'Start Your School Software',
    formSubtitle:
      'Share your school, tuition class, or coaching institute workflow and we will help you plan the right setup.',
    trackingFormName: 'school-management-software inquiry form',
  },
};

const ProductSchoolManagement = () => (
  <ServicePageTemplate {...schoolManagementConfig} />
);

export default ProductSchoolManagement;
